module.exports = "https://www.gc-pro.gnp.com.mx/c64234b1da57bdcf947dfae7a37fae28.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-video-8.png
// module id = 957
// module chunks = 0 1